import { Box as MuiBox, styled } from "@mui/material";

export const ButtonsWrapper = styled(MuiBox)(
  () => `
    padding: 0 20px 20px;
  `
);
